import gameStates    from './gameStates';
import game          from './game';
import auction       from './auction';
import player        from './player';
import hands         from './hands';
import highlighting  from './highlighting';
import hiding        from './hiding';
import dds           from './dds';
import turning       from './turning';
import table         from './table';
import parameters    from './parameters';
import studyAuction  from './studyAuction';
import studyTricks   from './studyTricks';

export default {

	...gameStates,
	...game,
	...auction,
	...player,
	...hands,
	...highlighting,
	...hiding,
	...dds,
	...turning,
	...table,
	...parameters,
	...studyAuction,
	...studyTricks

};
